import {LocalDate} from '@js-joda/core';

export class PayrollApply {
  public payrollIds?: number[] = [];
  public payrollDate?: LocalDate;
}
